<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<digit v-if='item.Property.Control=="Number"' :data-val='item'></digit>
			<contact v-if='item.Property.Control=="Condition"' :data-val="item"></contact>
			<dates v-if='item.Property.Control=="Date"' :data-val="item"></dates>
			<version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></version>
			<money v-if='item.Property.Control=="Money"' :data-val="item"></money>
			<tips v-if='item.Property.Control=="Tips"' :data-val="item"></tips>
			<file v-if='item.Property.Control=="File"' :data-val="item"></file>
			<tables v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></tables>
			<selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></selector>
			<textArea v-if='item.Property.Control=="Textarea"' :data-val='item'></textArea>
		</div>
		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
	</div>
</template>
<script>

	import stringUtils from "../../assets/js/stringUtil.js";
    import { getTemplateInfo,submitProcess } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		// components: {
		// 	Contact,
		// 	Dates,
		// 	Version,
		// 	Money,
		// 	Tips,
		// 	File,
		// 	Table,
		// 	Digit,
		// 	Selector,
		// 	Textarea
		// },
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			this.getEmployeeRelation();
			stringUtils.setDeleteIsShow(false);
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			getTemplate() {
				getTemplateInfo(this.templateId).then(response => {
					var controls = response.Body;
					this.templateData = this.assignControl(controls, this.logInfo);
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {

				this.$forceUpdate()
			},
			tableOperation(val, type) {
				this.tableoperation(val, type, this.templateData.TemplateContent.Controls);
			},
			submit() {
				
			}
		},
	}
</script>
